// Module
var code = "<h2 id=\"in-school-or-in-gracedevelop-a-repayment-strategy\">In School or In Grace&mdash;Develop a Repayment Strategy</h2> <p>Plan ahead before repayment starts to ensure timely and complete loan repayment. </p> ";
// Exports
export default code;